<template>
  <div v-if="!showModuloForm">
    <MarketingModules />
  </div>
  <div class="page" v-else>
    <Panel lineColor="var(--primary-color)">
      <template v-slot:options>
        <FormButtonGroup align="end" spaced>
          <FormButton type="primario" @click="novoAgrupador">
            Novo Agrupador
          </FormButton>
        </FormButtonGroup>
      </template>
      <DataTable
        ref="datatable"
        :headers="headers"
        :endpoint="endpoint"
        sortBy="descricao"
        :sortDesc="false"
        search
        @click="onClick"
      >
        <template v-slot:formas_pagamento="{ col }">
          <div class="formas-pagamento">
            <span
              v-for="forma in limitarFormas(col)"
              :key="forma"
              class="chip-forma"
            >
              {{ forma }}
            </span>
            <span
              v-if="contarFormas(col) > maxFormasExibidas"
              class="chip-extra"
            >
              + {{ contarFormas(col) - maxFormasExibidas }} formas
            </span>
          </div>
        </template>
        <template v-slot:ativo="{ col }">
          <span :class="['status-chip', col ? 'ativo' : 'inativo']">
            {{ col ? "Ativo" : "Inativo" }}
          </span>
        </template>
        <template v-slot:idagrupadorformapagto="{ row }">
          <FormButtonMenu
            icon
            :options="tableOptions"
            @click="op => selectOption(row, op)"
          >
            <v-icon size="15">fas fa-ellipsis-v</v-icon>
          </FormButtonMenu>
        </template>
      </DataTable>
    </Panel>
    <transition name="slide-popup" mode="out-in">
      <router-view class="view" @close="onClose"></router-view>
    </transition>
  </div>
</template>

<script>
import Panel from "@/components/Panel";
import DataTable from "@/components/DataTable";
import FormButtonGroup from "@/components/form/FormButtonGroup";
import FormButtonMenu from "@/components/form/FormButtonMenu";
import FormButton from "@/components/form/FormButton";
import MarketingModules from "@/components/MarketingModules";
import { ModulesEnum } from "@/store/actions/modulesEnum";
import { mapGetters } from "vuex";
import { AGRUPADOR_PAGAMENTO_DELETE } from "@/store/actions/agrupadorPagamento";

export default {
  name: "AgrupadorPagamento",
  components: {
    Panel,
    DataTable,
    FormButtonGroup,
    FormButtonMenu,
    FormButton,
    MarketingModules
  },
  data: () => ({
    headers: [
      { text: "Nome do agrupador", value: "descricao" },
      { text: "Formas vinculadas", value: "formas_pagamento", sortable: false },
      { text: "Ordenação", value: "ordenacao", align: "center" },
      { text: "Status", value: "ativo", align: "center" },
      {
        text: "Opções",
        value: "idagrupadorformapagto",
        align: "center",
        clickable: false,
        sortable: false
      }
    ],
    tableOptions: [
      { text: "Editar", value: "edit" },
      { text: "Deletar", value: "delete" }
    ],
    maxFormasExibidas: 4,
    modulosForm: [
      ModulesEnum.ORCAMENTO_WEB,
      ModulesEnum.ORCAMENTO_APP,
      ModulesEnum.VENDAMAIS_WEB,
      ModulesEnum.VENDAMAIS_APP,
      ModulesEnum.WEB_COMMERCE,
      ModulesEnum.COMMERCE_APP
    ]
  }),
  computed: {
    ...mapGetters(["getFornecedorId", "moduloFornecedorAtivo"]),
    endpoint() {
      return `/api/v4/payment-group/${this.getFornecedorId}/datatable`;
    },
    showModuloForm() {
      return this.moduloFornecedorAtivo(this.modulosForm);
    }
  },
  methods: {
    limitarFormas(formas) {
      if (!formas) return [];
      const lista = Array.isArray(formas) ? formas : [formas];
      return lista.slice(0, this.maxFormasExibidas);
    },
    contarFormas(formas) {
      if (!formas) return 0;
      return Array.isArray(formas) ? formas.length : 1;
    },
    onClose() {
      if (this.$refs && this.$refs.datatable) {
        this.$refs.datatable.reload();
      }
    },
    onClick(item) {
      if (!item || !item.idagrupadorformapagto) return;
      this.$router.push(
        `/fornecedor/cadastro/agrupador/forma-pagamento/${item.idagrupadorformapagto}`
      );
    },
    novoAgrupador() {
      this.$router.push("/fornecedor/cadastro/agrupador/forma-pagamento/novo");
    },
    selectOption(item, option) {
      if (!item || !option) return;
      switch (option.value) {
        case "edit":
          this.onClick(item);
          break;
        case "delete":
          this.confirmarRemocao(item);
          break;
      }
    },
    confirmarRemocao(item) {
      this.$swal
        .fire({
          title: "Remover agrupador de pagamento?",
          text: "Essa ação é irreversível",
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "Confirmar",
          cancelButtonText: "Cancelar",
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            this.removerAgrupador(item);
          }
        });
    },
    removerAgrupador(item) {
      this.$store
        .dispatch(AGRUPADOR_PAGAMENTO_DELETE, item.idagrupadorformapagto)
        .then(() => {
          this.$vueOnToast.pop(
            "success",
            "Agrupador de pagamento removido com sucesso"
          );
          if (this.$refs && this.$refs.datatable) {
            this.$refs.datatable.reload();
          }
        });
    }
  }
};
</script>

<style scoped>
.formas-pagamento {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.chip-forma {
  display: inline-flex;
  align-items: center;
  padding: 4px 8px;
  border-radius: 12px;
  background: var(--auxiliar-color);
  color: #fff;
  font-size: 12px;
}

.chip-extra {
  font-size: 12px;
  color: var(--text-color);
  margin-left: 4px;
}

.status-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 70px;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
}

.status-chip.ativo {
  background: rgba(57, 181, 74, 0.15);
  color: #39b54a;
}

.status-chip.inativo {
  background: rgba(217, 83, 79, 0.15);
  color: #d9534f;
}
</style>
